import './Popover-a93df39c.css';

var classes = {"Popover":"prc-Popover-Popover-v1ShS","PopoverContent":"prc-Popover-PopoverContent-nMzFS"};

export { classes as default };
